import Chart from "chart.js";

const mode = "light";
const fonts = {
  base: "Open Sans"
};

const colors = {
  gray: {
    100: "#f6f9fc",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#8898aa",
    700: "#525f7f",
    800: "#32325d",
    900: "#212529"
  },
  theme: {
    default: "#172b4d",
    primary: "#5e72e4",
    secondary: "#f4f5f7",
    info: "#11cdef",
    success: "#2dce89",
    danger: "#f5365c",
    warning: "#fb6340"
  },
  black: "#12263F",
  white: "#FFFFFF",
  transparent: "transparent"
};

export const parseOptions = (parent, options) => {
  for (var item in options) {
    if (typeof options[item] !== "object") {
      parent[item] = options[item];
    } else {
      parseOptions(parent[item], options[item]);
    }
  }
};

export function chartOptions() {
  var options = {
    defaults: {
      global: {
        responsive: true,
        maintainAspectRatio: false,
        defaultColor: colors.gray[600],
        defaultFontColor: colors.gray[600],
        defaultFontFamily: fonts.base,
        defaultFontSize: 13,
        layout: {
          padding: 0
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 10,
            usePointStyle: false,
            fontColor: 'black',
          },
        },
        elements: {
          point: {
            radius: 0,
            backgroundColor: colors.theme["primary"]
          },
          line: {
            tension: 0.05,
            borderWidth: 4,
            borderColor: colors.theme["primary"],
            backgroundColor: colors.transparent,
            borderCapStyle: "rounded"
          },
          rectangle: {
            backgroundColor: colors.theme["warning"]
          },
          arc: {
            backgroundColor: colors.theme["primary"],
            borderColor: colors.white,
            borderWidth: 4
          }
        },
        tooltips: {
          enabled: true,
          mode: "index",
          intersect: false
        }
      },
      doughnut: {
        cutoutPercentage: 83,
        legendCallback: function(chart) {
          var data = chart.data;
          var content = "";

          data.labels.forEach(function(label, index) {
            var bgColor = data.datasets[0].backgroundColor[index];

            content += '<span class="chart-legend-item">';
            content +=
              '<i class="chart-legend-indicator" style="background-color: ' +
              bgColor +
              '"></i>';
            content += label;
            content += "</span>";
          });

          return content;
        }
      }
    }
  };

  // yAxes
  Chart.scaleService.updateScaleDefaults("linear", {
    gridLines: {
      borderDash: [2],
      borderDashOffset: [2],
      color: colors.gray[300],
      drawBorder: false,
      drawTicks: false,
      lineWidth: 0,
      zeroLineWidth: 0,
      zeroLineColor: colors.gray[300],
      zeroLineBorderDash: [2],
      zeroLineBorderDashOffset: [2]
    },
    ticks: {
      beginAtZero: true,
      padding: 10,
      callback: function(value) {
        if (!(value % 10)) {
          return value;
        }
      }
    }
  });

  // xAxes
  Chart.scaleService.updateScaleDefaults("category", {
    gridLines: {
      drawBorder: false,
      drawOnChartArea: false,
      drawTicks: false
    },
    ticks: {
      padding: 20
    },
    maxBarThickness: 10
  });

  return options;
}

export function randomColor() {
  const options = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += options[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function randomScalingFactor() {
  return Math.round(Math.random() * 100);
}

export const chartBarStackedData = {
  options: {
    legend: {
      display: false,
    },
    tooltips: {
      mode: 'index',
      intersect: false,
    },
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
            max: 50,
            value: 2,
          },
        },
      ],
    },
  },
  data: {
    labels: [],
    datasets: [],
  }
};

export const chartSalesData = {
  options: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 15,
            value: 0.5,
            step: 0.5,
          },
        },
      ],
    },
  },
  data: {
    labels: [],
    datasets: []
  }
};

export const chartPieData = {
  options: {
    responsive: true,
    animation: {
      animateScale: true,
      animateRotate: true,
    },
  },
  data: {
    labels: [],
    datasets: []
  },
};

export const chartBarsData = {
  options: {
    responsive: true,
    legend: {
      display: false,
    },
    borderWidth: 20,
    scales: {
      xAxes: [
        {
          stacked: true,
        },
      ],
    },
  },
  data: {
    labels: [],
    datasets: []
  }
};

export const chartHorizontalBarsData = {
  options: {
    responsive: true,
    legend: {
      display: false,
    },
    borderWidth: 20,
    scales: {
      xAxes: [
        {
          stacked: true
        },
      ],
    },
  },
  data: {
    labels: [],
    datasets: []
  }
};

export const chartPointsData = {
  options: {
    scales: {
      yAxes: [
        {
          gridLines: {
            color: colors.gray[200],
            zeroLineColor: colors.gray[200]
          },
          ticks: {}
        }
      ]
    }
  },
  data: {
    labels: [],
    datasets: []
  }
};

export const chartDoughnutData = {
  options: {
    responsive: true,
    legend: {
      position: "top"
    },
    animation: {
      animateScale: true,
      animateRotate: true
    }
  },
  data: {
    labels: [],
    datasets: []
  }
};

export const chartPolarData = {
  options: {
    responsive: true,
    legend: {
      position: "top"
    },
    animation: {
      animateScale: true,
      animateRotate: true
    }
  },
  data: {
    labels: [],
    datasets: []
  }
};

